<template>
  <input
    id="gAddress"
    type="text"
    ref="gAddress"
    placeholder="Address Line 1"
    maxlength="45"
    :class="gClass"
    :value="value"
    @input="inputChange"
  />
</template>
<script>
export default {
  name: 'google-autocomplete',
  props: {
    value: String,
    gClass: {
      type: Array,
      default() {
        return []
      }
    },
    country: {
      type: String,
      default() {
        return 'US'
      }
    },
  },
  data(){
    return {
      address: '',
      autoComplete: null,
      placesDetail: {}
    }
  },
  watch: {
    country: function(newVal, oldVal) {
      const gField = this.$refs.gAddress;
      if (newVal.toUpperCase() == 'US') {
        const bounds = new google.maps.LatLngBounds(
          new google.maps.LatLng(-90,-180),
          new google.maps.LatLng(90,180)
        );
        this.autoComplete = new google.maps.places.Autocomplete(gField, {bounds});
        this.autoComplete.setComponentRestrictions({ // restrict the country
          country: ["us"]
        })
        this.autoComplete.setFields(['name', 'address_components']);
        this.autoComplete.addListener('place_changed', this.placeChanged)
      } else {
        google.maps.event.clearInstanceListeners(gField);
        this.autoComplete = null
      }
    }
  },
  mounted(){
    if (this.country == 'US') {
      const gField = this.$refs.gAddress;
      console.log('G-Field', gField);
      const bounds = new google.maps.LatLngBounds(
        new google.maps.LatLng(-90,-180),
        new google.maps.LatLng(90,180)
      );
      this.autoComplete = new google.maps.places.Autocomplete(gField, {bounds});
      this.autoComplete.setComponentRestrictions({ // restrict the country
        country: ["us"]
      })
      this.autoComplete.setFields(['name', 'address_components']);
      this.autoComplete.addListener('place_changed', this.placeChanged)
    }
  },
  methods: {
    async inputChange(e){
      // console.log('input change value: ', e.target.value);
      const address = e.target.value;
      console.log('address: ', address);
      this.address = address;
      this.$emit('input', address);
    },

    placeChanged(){
      // name - address
      // locality / sublocality - city
      // administrative_area_level_1 - state
      // country - country
      // postal_code - postal code
      const { name, address_components } = this.autoComplete.getPlace();
      console.log('address components: ', address_components);
      const toAddress = {
        city: '',
        state: '',
        country: '',
        postal_code: ''
      };
      const USTeritorries = ["AMERICAN SAMOA", "FEDERATED STATES OF MICRONESIA",
      "GUAM", "MARSHALL ISLANDS", "NORTHERN MARIANA ISLANDS",
      "PUERTO RICO","PALAU", "U.S. VIRGIN ISLANDS", "U.S. MINOR OUTLYING ISLANDS"];

      if(address_components){
        let temp_city = '';
        for (var i = 0; i < address_components.length; i++) {

          const {short_name, long_name, types} = address_components[i];
          switch(types[0]){
            case 'locality':
              toAddress.city = long_name;
              break;
            case 'administrative_area_level_1':
              if(!toAddress.province) toAddress.province = short_name;
            break;
            case 'country':
              console.log(long_name.toUpperCase(), short_name);
              if(USTeritorries.includes(long_name.toUpperCase())){
                toAddress.province = short_name;
                toAddress.country = "US";
              } else {
                toAddress.country = short_name;
              }
            break;
            case 'postal_code':
            toAddress.postal_code = long_name;
            break;
            default:
              if(types[0].includes('sublocality')) temp_city = long_name;
          }
        } // end for
        if(!toAddress.city) toAddress.city = temp_city;
        this.$emit('change', Object.assign({country: 'US'}, toAddress));
      }
      if(name) this.$emit('input', name);
    }
  }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/GoogleAutoComplete.vue